import { MapPin, Mail } from 'lucide-react';
import { useLang } from '../i18n';
import Seo from '../components/Seo';
import { Brush } from '../components/Brush';

export default function Contact() {
  const { t } = useLang();

  return (
    <>
      <Seo title={t('contact.title')} description={t('contact.lead')} path="/contatti" />

      <header className="py-14 md:py-20">
        <div className="wrap">
          <h1 className="relative inline-block">
            <span className="display-xl">{t('contact.title')}</span>
            <Brush className="absolute -bottom-1 left-0 h-[0.34em] w-full" opacity={0.32} />
          </h1>
          <p className="prosa mt-8 border-t-2 border-inchiostro pt-6 text-lg">{t('contact.lead')}</p>
        </div>
      </header>

      <section className="py-14 md:py-20">
        <div className="wrap grid gap-14 lg:grid-cols-[1.15fr_1fr] lg:gap-24">
          <p data-testid="contact-form-off" className="prosa text-lg">
            {t('common.formOff')}
          </p>

          <aside className="lg:pt-3">
            <p className="accento mb-7 text-2xl text-inchiostro/85">{t('contact.infoTitle')}</p>
            <dl>
              {[
                [t('contact.hq'), 'Tivoli (RM), Italia', <MapPin key="m" size={14} />],
                [t('contact.commercial'), 'commerciale@vde.it', <Mail key="c" size={14} />],
                [t('contact.pressLabel'), 'stampa@vde.it', <Mail key="p" size={14} />],
                ['Prodotto', 'prodotto@vde.it', <Mail key="pr" size={14} />],
              ].map(([k, v, icon]) => (
                <div key={k} className="py-5">
                  <dt className="label !mb-1">{k}</dt>
                  <dd className="flex items-center gap-2 text-base text-inchiostro/80">
                    <span className="text-marsala">{icon}</span>
                    {v}
                  </dd>
                </div>
              ))}
            </dl>
          </aside>
        </div>
      </section>
    </>
  );
}
